// file for ? decide is need to use it or not...we could simply list all the categories of marketing services in the page without going to another page for more...

import React from 'react';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import particlesConfig from '../../Shared/pr-s-black';
import '../../Assets/Stylesheets/Pages/MarketingServices/MoreMS.scss';

export default function MoreMS() {
  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  return (
    <div className="more-ms-page">
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={particlesConfig}
        className="particles-background"
      />
      <div className="more-ms-content">
        <h1>More Services Coming Soon</h1>
      </div>
    </div>
  );
}